import Vue from 'vue';
import moment from 'moment';

export default {

    setNowUtc({ commit, dispatch, state }) {
        if(state.nowUtc === ''){
            commit('SET_NOW_UTC', moment.utc().format());
        }
        setTimeout(() => {
            commit('SET_NOW_UTC', moment.utc().format());
            dispatch('setNowUtc');
        }, 300000);
    },
    async createBlobFromUrl (context, {imageUrl, addBackgroundToImage=false}){
        const url = imageUrl;
        let logoFile = await fetch(url)
            .then(res => res.blob())
            .then(async blob => {
                if(addBackgroundToImage){
                    const image = await context.dispatch('addBackgroundToImageOnUpload', blob);
                    return image.file;
                }else{
                    const ext = blob.type.split('/')[1];
                    return new File([blob], `File name.${ext}`, {
                        type: blob.type,
                    });
                }
            });
        return logoFile;
    },
    async addBackgroundToImageOnUpload (context, selectedImageAsBlob){
        let width = 100;
        let height = 100;
        let img;
        let readFileAsync = async () => {
            return new Promise((resolve) => {
                let fr = new FileReader();
                fr.onload = async () => {
                    img = new Image;
                    img.onload = async () => {
                        width = img.width;
                        height = img.height;
                        resolve();
                    };
                    img.src = fr.result;
                };
                fr.readAsDataURL(selectedImageAsBlob);

            });
        };
        await readFileAsync();
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        ctx.canvas.width  = width;
        ctx.canvas.height = height;
        ctx.fillStyle = 'rgb(255, 255, 255)';
        ctx.fillRect(0, 0, width, height);
        ctx.drawImage(img, 0, 0, width, height);
        const file = await new Promise((resolve) => {
            canvas.toBlob(async function(blob) {
                resolve(new File([blob], 'default-taker-logo.jpg', {
                    type: blob.type,
                }));
            });
        });
        return {
            file: file,
            url: canvas.toDataURL()
        };
    },
};



// WEBPACK FOOTER //
// ./src/store/actions.js